export const SITE_NAME = "Mark Egly Golf";
export const SITE_LEGAL_NAME = "Des Moines Driving Range";

/** Canonical apex host. All other brand domains 301 here. */
export const SITE_PRIMARY_HOST = "markeglysports.com";

/**
 * Other hosts that serve this site and must redirect to SITE_PRIMARY_HOST.
 * Include apex only; www variants are derived for Netlify redirects.
 */
export const SITE_ALIAS_HOSTS = [
  "markegly.com",
  "desmoinesdrivingrange.com",
  "golflessonsdesmoines.com",
] as const;

/** Canonical origin for SEO (canonical URLs, Open Graph, sitemap). Set VITE_SITE_URL in production. */
export const SITE_ORIGIN = (
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_SITE_URL) ||
  `https://${SITE_PRIMARY_HOST}`
).replace(/\/$/, "");

export const SITE_ADDRESS = {
  street: "2944 NW 66th Ave",
  city: "Des Moines",
  state: "IA",
  zip: "50313",
  full: "2944 NW 66th Ave, Des Moines, IA 50313",
};

/** Opens the device maps app on mobile; Google Maps in the browser on desktop. */
export const SITE_MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(SITE_ADDRESS.full)}`;

export const SITE_PHONE = "515-289-1703";
export const SITE_PHONE_TEL = "tel:5152891703";
export const SITE_PHONE_E164 = "+15152891703";
export const SITE_EMAIL = "markeglysports@gmail.com";

export const SITE_SOCIAL = {
  facebook: "https://www.facebook.com/desmoinesdrivingrange",
  instagram: "https://www.instagram.com/thedesmoinesdrivingrange",
  youtube: "https://www.youtube.com/user/MarkEgly",
  twitter: "https://twitter.com/DSMDrivingRange",
  linkedin: "https://www.linkedin.com/in/markegly",
} as const;

/** Hostnames that should 301 to the primary apex (aliases + all www variants). */
export function siteRedirectSourceHosts(): string[] {
  const hosts = new Set<string>([`www.${SITE_PRIMARY_HOST}`]);
  for (const host of SITE_ALIAS_HOSTS) {
    hosts.add(host);
    hosts.add(`www.${host}`);
  }
  return [...hosts].sort();
}
